<template>
  <div style="width: 50%" v-if="preferences.length > 0">
    <div class="ml-2 pb-4 text-body-1">{{ $t('conflict.alreadyCreatedPreferences') }}:</div>

    <option-block
      v-for="sw in scenariosWithWigoList"
      :key="sw.scenario.id"
      :list-label="`Scenario ${ sw.scenario.id } - level ${ sw.scenario.level }`"
      :options="sw.wigo"
      :elements="filterElementsOfCurrentContext(sw.scenario.elements)"
      :belief-mode="beliefMode"
      :asGroup="sw.isGroup"
    />

  </div>
</template>

<script>
import OptionBlock from '@/components/global/OptionBlock';
import believeService from '@/services/believes.js';
import _ from 'lodash';
// todo: improvments possible: show logos ? pref or scenario id ? only show pref of scenarios with previousLevel Scenarios = current scenario ?
export default {
  name: 'CreatedPreferences',

  components: { OptionBlock },

  props: {
    preferences: {
      type: Array,
      required: true,
    },
    currentElements: {
      type: Array,
      required: true,
    },
    beliefMode: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  computed: {
   /**
    * returns deduplicates scenario&wigo list based on input PrefList
    * @return {scenario: scenario, wigo: option[]}[]
    */
    scenariosWithWigoList () {
      const scenariosWithWigo = this.preferences.map(pref => {
        return {
          scenario: pref.scenario, 
          wigo: [ pref[this.wigoProperty] ],
          isGroup: !!pref.groupId
        }
      })
      const generateId = (sw) => `${sw.scenario.id}-${sw.wigo.map(o => o.id).sort().join(',')}` 
      return _.uniqWith(scenariosWithWigo, (sw1, sw2) => generateId(sw1) === generateId(sw2));
    },

    wigoProperty() {
      return believeService.wigoProperty(this.beliefMode);
    },
  },

  methods: {
    filterElementsOfCurrentContext(elements) {
      // console.log('filterElementsOfCurrentContext')
      // console.log(elements)
      // console.log(this.currentElements)
      let filtered = elements
        .filter(elt => !this.currentElements.includes(elt.id));
      return filtered;
    },
  }
};
</script>